
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8bJxr", function(module, exports) {
$parcel$export(module.exports, "default", () => $07ecf74e638a84ee$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");


var $l8wPz = parcelRequire("l8wPz");


var $KTiWz = parcelRequire("KTiWz");

var $3F4bj = parcelRequire("3F4bj");

var $dUm2W = parcelRequire("dUm2W");


var $jzDd9 = parcelRequire("jzDd9");


var $iIYTj = parcelRequire("iIYTj");


var $ijHEK = parcelRequire("ijHEK");


var $6FNab = parcelRequire("6FNab");


var $gPRUa = parcelRequire("gPRUa");


var $gBjHb = parcelRequire("gBjHb");


var $aK1EY = parcelRequire("aK1EY");


var $QXwxo = parcelRequire("QXwxo");


var $iDrrr = parcelRequire("iDrrr");


var $h9Lux = parcelRequire("h9Lux");

var $k3XQC = parcelRequire("k3XQC");


var $3uhT3 = parcelRequire("3uhT3");


var $96p1s = parcelRequire("96p1s");

function $07ecf74e638a84ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07ecf74e638a84ee$var$datasourceCenterWrapperStyles = {
    name: "1j6bn2d",
    styles: "margin-top:var(--ds-space-150, 12px);margin-bottom:var(--ds-space-150, 12px)"
};
const $07ecf74e638a84ee$var$datasourceContainerStyleWithMarginTop = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: `${"var(--ds-radius-large, 8px)"}`,
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    overflow: 'hidden',
    marginTop: `${"var(--ds-space-150, 12px)"}`,
    marginBottom: `${"var(--ds-space-150, 12px)"}`
});
// No vertical margin when inside center wrapper (wrapper has margin so it participates in collapse).
const $07ecf74e638a84ee$var$datasourceContainerStyleNoVerticalMargin = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: `${"var(--ds-radius-large, 8px)"}`,
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    overflow: 'hidden'
});
function $07ecf74e638a84ee$export$2e2bcd8739ae039(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, smartLinks: smartLinks, isNodeNested: isNodeNested, localId: localId, onSetLinkTarget: onSetLinkTarget } = props;
    const portal = (0, $3uhT3.usePortal)(props);
    const { actionOptions: actionOptions } = smartLinks || {};
    // Card/CardSSR's onClick — (e, { destinationUrl?, url? })
    const onClick = (0, $ijHEK.getCardClickHandler)(eventHandlers, url);
    // SmartCardEventClickHandler — (e, url?) => void — for CardErrorBoundary.
    // When the gate is off, fall back to the old behaviour (pass the same onClick as Card).
    const onConsumerClick = (0, $6FNab.getEventHandler)(eventHandlers, 'smartCard');
    const platform = 'web';
    const cardProps = {
        url: url,
        data: data,
        onClick: onClick,
        container: portal,
        isDatasource: !!props.datasource,
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    const onError = ({ err: err })=>{
        if (err) throw err;
    };
    if (props.datasource) {
        const views = props.datasource.views;
        const tableView = views.find((view)=>view.type === 'table');
        const shouldRenderDatasource = tableView && (0, $k3XQC.canRenderDatasource)(props.datasource.id);
        if (shouldRenderDatasource) {
            const columns = tableView.properties?.columns;
            const visibleColumnKeys = columns?.map(({ key: key })=>key);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            const columnCustomSizesEntries = columns?.filter((c)=>!!c.width).map(({ key: key, width: width })=>[
                    key,
                    width
                ]);
            const columnCustomSizes = columnCustomSizesEntries?.length ? Object.fromEntries(columnCustomSizesEntries) : undefined;
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            const wrappedColumnKeys = columns?.filter((c)=>c.isWrapped).map((c)=>c.key);
            const { datasource: datasource, layout: layout } = props;
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $jzDd9.CardErrorBoundary), {
                unsupportedComponent: (0, $3F4bj.default),
                datasourceId: props.datasource.id,
                onSetLinkTarget: onSetLinkTarget,
                ...cardProps,
                onClick: onConsumerClick
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthConsumer), null, ({ width: width })=>{
                const useCenterWrapper = !isNodeNested;
                const datasourceDiv = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: useCenterWrapper ? $07ecf74e638a84ee$var$datasourceContainerStyleNoVerticalMargin : $07ecf74e638a84ee$var$datasourceContainerStyleWithMarginTop,
                    "data-testid": "renderer-datasource-table",
                    "data-local-id": localId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        width: isNodeNested ? '100%' : (0, $h9Lux.calcBreakoutWidth)(layout, width)
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aK1EY.DatasourceTableViewWithWrappers), {
                    datasourceId: datasource.id,
                    parameters: datasource.parameters,
                    visibleColumnKeys: visibleColumnKeys,
                    columnCustomSizes: columnCustomSizes,
                    wrappedColumnKeys: wrappedColumnKeys && wrappedColumnKeys.length > 0 ? wrappedColumnKeys : undefined,
                    url: url
                }));
                return useCenterWrapper ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: (0, $96p1s.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER,
                    css: $07ecf74e638a84ee$var$datasourceCenterWrapperStyles
                }, datasourceDiv) : datasourceDiv;
            })));
        }
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gPRUa.default), {
            data: data,
            url: url
        });
    }
    let cardComponent;
    if (smartLinks?.ssr && url && // Clean up feature gates when both are fully rolled out.
    // - platform_ssr_smartlink_cards: Controls SSR smart links for confluence (100% rolled out)
    // - jfp-magma-ssr-iv-editor-links: Controls SSR smart links for jira (at time of comment: 50% rolled out)
    // Once both gates are 100% rolled out, remove this condition entirely and make
    // smart link SSR behavior the default.
    // NOTE: This is a temporary solution to allow for the gradual rollout of SSR smart links for jira and keep it
    // fully rolled out for confluence since both gates target different products keep only one gate to control the behavior
    // isnt correct.
    ((0, $iDrrr.fg)('platform_ssr_smartlink_cards') || (0, $iDrrr.fg)('jfp-magma-ssr-iv-editor-links'))) cardComponent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $QXwxo.CardSSR), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        url: url,
        onError: onError,
        hideIconLoadingSkeleton: true
    });
    else cardComponent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l8wPz.Card), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        onError: onError
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iIYTj.SmartLinkDraggable), {
        url: url || '',
        appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).BLOCK,
        source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).RENDERER
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gBjHb.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "blockCardView-content-wrap",
        "data-block-card": true,
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $jzDd9.CardErrorBoundary), {
        unsupportedComponent: (0, $KTiWz.default),
        onSetLinkTarget: onSetLinkTarget,
        ...cardProps,
        onClick: onConsumerClick
    }, cardComponent))));
}

});

parcelRegister("aK1EY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $f1b26a0986b97fb7$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8DrKG")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $f1b26a0986b97fb7$export$2f5bdb66685d3fb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
            ...props
        })
    });
};
module.exports["DatasourceTableViewWithWrappers"] = $f1b26a0986b97fb7$export$2f5bdb66685d3fb4;

});

parcelRegister("8DrKG", function(module, exports) {

let $64977e349cd71c00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $64977e349cd71c00$var$load("f4Nog"),
    $64977e349cd71c00$var$load("6wr18"),
    $64977e349cd71c00$var$load("ev1iQ"),
    $64977e349cd71c00$var$load("h1naV"),
    $64977e349cd71c00$var$load("aEiTV"),
    $64977e349cd71c00$var$load("iQvHF"),
    $64977e349cd71c00$var$load("kwaPJ"),
    $64977e349cd71c00$var$load("3ayyN"),
    $64977e349cd71c00$var$load("4B1fg"),
    $64977e349cd71c00$var$load("cuHdd"),
    $64977e349cd71c00$var$load("iWnyc"),
    $64977e349cd71c00$var$load("hhss7"),
    $64977e349cd71c00$var$load("ffEVr"),
    $64977e349cd71c00$var$load("Wowvf"),
    $64977e349cd71c00$var$load("lkxmG"),
    $64977e349cd71c00$var$load("7EorR"),
    $64977e349cd71c00$var$load("3WGfe")
]).then(()=>parcelRequire('khl4A'));

});


//# sourceMappingURL=blockCard.0bca6ee8.js.map
